export const UTILISATION_REPORT_YEAR_THRESHOLD = 2024;